/**
 * Locale readiness for quest narrative content.
 * empty — no package yet
 * generated — AI wrote it, not human-reviewed
 * reviewed — moderator accepted this language
 */
export enum CityQuestLocaleStatusEnum {
    EMPTY = 'empty',
    GENERATED = 'generated',
    REVIEWED = 'reviewed',
}
